module.exports = __webpack_public_path__ + "img/Kosovo.12d401c8.svg";